import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-682df3c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tgConvList" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { useRoute } from 'vue-router';
import { useStore } from "vuex";
import { computed, onMounted } from "vue";
import { TgActions, TgGetters, TgMutations } from "@/store/modules/telegram";
import { TgConversation } from "@/store/modules/telegram/types";
import TgSessionCard from "@/components/telegram/TgSessionCard.vue";



import { defineComponent } from "vue";

const __default__ = defineComponent({
    name: "TgConvWindow",
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const route = useRoute();
const store = useStore();
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])

const tgIdCom = computed(() => {
    return store.getters[`telegram/${TgGetters.getMeId}`];
});

const tgIdIsLoading = computed(() => {
    return store.getters[`telegram/${TgGetters.getMeIdIsLoading}`];
});

const isConvAllLoaded = computed(() => {
    return store.getters[`telegram/${TgGetters.getConvAllLoaded}`];
});

const isConvLoading = computed(() => {
    return store.getters[`telegram/${TgGetters.getIsConvLoading}`];
});

const convList = computed(() => {
    return store.getters[`telegram/${TgGetters.getConvList}`];
});

const selectedConv = computed(() => {
    return store.getters[`telegram/${TgGetters.getSelectedConv}`];
});


const loadTgConvList = async () => {
    if (tgIdCom.value !== 0 && !tgIdIsLoading.value && !isConvAllLoaded.value && !isConvLoading.value) {
        const projId = projectId.value
        const uid = targetId.value;
        const tgId = tgIdCom.value;
        const isAppend = true;
        try {
            await store.dispatch(`telegram/${TgActions.asyncGetConvListByUidAndTgId}`, { projId, uid, tgId, isAppend });
        } catch (err) {
            console.log(err);
        }
    }
}

const isConvSelected = (convId: number) => {
    if (selectedConv.value) {
        return selectedConv.value.ConversationID === convId;
    } else {
        return false
    }
}

const handleClick = (conv: TgConversation) => {
    store.commit(`telegram/${TgMutations.setSelectedConv}`, conv);
}

const getDisplayName = (conv: TgConversation) => {
    if (conv.Title !== "") {
        return conv.Title;
    } else if (conv.Name !== "") {
        return conv.Name;
    } else {
        return "[用户名未知]";
    }
}

const getConvName = (conv: TgConversation) => {
    if (conv.Type === 'user') {
        return conv.Title === '' ? conv.Name : `${conv.Name}（${conv.Title}）`
    } else {
        return conv.Title === '' ? conv.Name : conv.Title

    }
}
const asyncGetTgIdList = async (projid: string, uid: string) => {
    store.dispatch(`telegram/${TgActions.asyncGetMeId}`, { projid, uid });
}


onMounted(async () => {
    let projid = projectId.value
    let uid = targetId.value
    try {
        await asyncGetTgIdList(projid, uid)
        await loadTgConvList()
    } catch (err) {
        console.log(err);
    }

});



return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(convList), (conv) => {
      return (_openBlock(), _createElementBlock("div", {
        key: conv.ConversationID
      }, [
        _createElementVNode("div", {
          class: _normalizeClass({ 'tgConv': true, 'tgConvActive': isConvSelected(conv.ConversationID) }),
          onClick: ($event: any) => (handleClick(conv))
        }, [
          _createElementVNode("div", null, [
            _createVNode(TgSessionCard, {
              msgSender: getConvName(conv),
              msgContent: '[消息内容]',
              target: ''
            }, null, 8, ["msgSender"])
          ])
        ], 10, _hoisted_2)
      ]))
    }), 128)),
    (_unref(isConvLoading))
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "加载中......"))
      : _createCommentVNode("", true),
    (_unref(isConvAllLoaded))
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "------已加载全部-------"))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _unref(tgIdIsLoading)],
    [_directive_infinite_scroll, loadTgConvList]
  ])
}
}

})